import getProjectFromPathname from 'js/sagas/sagaHelpers/getProjectFromPathname';
import { ExistingScribeModel } from 'js/types';
import { call, select, takeEvery } from 'redux-saga/effects';
import { SET_QUICK_IMAGE_SEARCH_TAG, SetQuickImageSearchTagAction } from 'js/actionCreators/ImageDrawerActions';
import { TRACK_IMAGE_SEARCH, TrackImageSearchAction } from 'js/actionCreators/trackingActions';
import { getImageSearchFilters } from 'js/sagas/selectors';

import { track } from '../mixpanelProvider';

function* trackQuickImageSearchTag({ tag }: SetQuickImageSearchTagAction) {
  const project = (yield call(getProjectFromPathname)) as ExistingScribeModel | undefined;
  if (!project) return;
  if (!tag) return;
  yield call(track, 'Use Quick Image Search Tag', {
    'Scribe ID': project.id,
    'Search Tag': tag
  });
}

function* trackSearchImage({ query, scribeId, tab }: TrackImageSearchAction) {
  const { filters }: ReturnType<typeof getImageSearchFilters> = yield select(getImageSearchFilters);

  const selectedFilters: { name: string; value: string }[] = [];
  filters.forEach(filter => {
    filter.values.forEach(value => {
      if (value.selected) {
        selectedFilters.push({ name: filter.title, value: value.name });
      }
    });
  });

  yield call(track, 'Search For Image', {
    'Scribe ID': scribeId,
    'Search Term': query,
    Tab: tab,
    Filters: selectedFilters.length > 0 ? selectedFilters : undefined
  });
}

export default function* trackImageDrawerSagas() {
  yield takeEvery(TRACK_IMAGE_SEARCH, trackSearchImage);
  yield takeEvery(SET_QUICK_IMAGE_SEARCH_TAG, trackQuickImageSearchTag);
}
